var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaywithPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.186 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.21039 20.651H6.97783C6.52016 20.651 6.14062 20.2714 6.14062 19.8138C6.14062 19.3561 6.52016 18.9766 6.97783 18.9766H9.21039C9.66807 18.9766 10.0476 19.3561 10.0476 19.8138C10.0476 20.2714 9.66807 20.651 9.21039 20.651Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1163 24H3.06977C1.37302 24 0 22.627 0 20.9302V3.06977C0 1.37302 1.37302 0 3.06977 0H13.1163C14.813 0 16.186 1.37302 16.186 3.06977V20.9302C16.186 22.627 14.813 24 13.1163 24ZM3.06977 1.67442C2.29954 1.67442 1.67442 2.29954 1.67442 3.06977V20.9302C1.67442 21.7005 2.29954 22.3256 3.06977 22.3256H13.1163C13.8865 22.3256 14.5116 21.7005 14.5116 20.9302V3.06977C14.5116 2.29954 13.8865 1.67442 13.1163 1.67442H3.06977Z",
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.7513 3.06996H5.43783C5.01365 3.06996 4.62295 2.83554 4.44435 2.45601L3.64062 0.837402H12.5709L11.7671 2.45601C11.5774 2.83554 11.1867 3.06996 10.7736 3.06996H10.7513Z",
    fill: "var(--fill-0, black)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaywithPhone);
export default __webpack_public_path__ + "static/media/staywith-phone.6ac3d91b9c1264e0d1783e8e9dbf038d.svg";
export { ForwardRef as ReactComponent };